import React, { useState } from 'react';
import { Alert, Col, Row } from 'react-bootstrap';
import * as DateFns from 'date-fns';

import { SERVER } from '../../../config/server.config';
import Loader from '../../Shared/Loader';
import { FUTURE_PRACTICE, GAME } from '../../../config/constants';
import TabSelector from '../../Shared/Filters/TabSelector';
import { routeToEventType } from '../../../helpers/helpersts';
import { useRouter } from '../../../helpers/customHooks';
import { useDataEventsState } from '../../../store/hooks';
import { checkPdf, requestPdf } from '../../../config/services/datasets';
import { message, notification } from 'antd';
import { useFlagsDispatch, useFlagsState } from 'store/hooks/flags';

const TabReports = () => {
  
  const { pathname, params } = useRouter();
  const { teamId } = params as { teamId?: string }; // teamId only for games
  const { dataEvent } = useDataEventsState();
  const eventType = routeToEventType(pathname);
  const [selected, setOption] = useState(7);
  const [errorPdf, setErrorPdf] = useState(false);
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(-1);
  const {  fileIsDownloading } = useFlagsDispatch();
  const{ download } = useFlagsState();

  // Exports Notification
  const notificationKey = 'downloadFinished';
  const notificationDownload = (name:string) => {
    const args = {
      key: notificationKey,
      message: 'Download In Progress',
      description:
        `Your file ${name} is being processed.`,
      duration: 0,
      icon: <i className='mdi mdi-download' style={{color: '#0378bf'}}></i>
    };
    notification.open(args);
  };
  const notificationDownloadFinish = (name:string) => {
    const args = {
      key: notificationKey,
      message: 'Download Finished',
      description: `Your file ${name} has been downloaded successfully.`,
      duration: 4,
      icon: <i className='mdi mdi-check-underline' style={{color: '#0378bf'}}></i>
    };
    notification.open(args);
  };
  const notificationDownloadError = (name:string) => {
    const args = {
      key: notificationKey,
      message: `Error downloading file ${name}`,
      duration: 4,
      icon: <i className='mdi mdi-alert' style={{color: 'red'}}></i>
    };
    notification.open(args);
  };
  
  const practiceDate = dataEvent.meta.startTime;
  const clickPDF = async () => {//`?teamId=${teamId}&compareRange=20190509-20190816`
    const dateRange = `${DateFns.format(DateFns.subDays(new Date(practiceDate), selected), 'yyyyMMdd')}-${DateFns.format(DateFns.subDays(new Date(practiceDate), 1), 'yyyyMMdd')}`;
    // fetch(SERVER.getPDFReport(practice.homeTeamId, dateRange, practice.gameId),
    //const urlFetch = `http://localhost:8080/pdf?teamId=${(event === GAME ? type : dataEvent.meta.homeTeam.teamId)}&compareRange=${dateRange}&dsid=${dataEvent.meta.gameId}`;
    //http://localhost:8080/pdf?teamId=${1}&compareRange=${2}&dsid=${3}
    const urlFetch = SERVER.getPDFReport((eventType === GAME ? teamId : dataEvent.meta.homeTeam.teamId), dateRange, dataEvent.meta.gameId);
   
    const sleep = (milliseconds: number) => {
      return new Promise(resolve => setTimeout(resolve, milliseconds));
    };
    fileIsDownloading(true);
    notificationDownload(`${dataEvent.meta.gameId}-${DateFns.format(new Date(practiceDate), 'MM-dd-yyyy')}.pdf`);
    let done;    
        do{
          done = await checkPdf(urlFetch + (eventType === GAME ? `&type=game&teamOfInterest=${teamId}` : '') + '&startTime=' + 
          DateFns.format(new Date(eventType === GAME || (!dataEvent.meta.drills || !dataEvent.meta.drills[0]) ? dataEvent.meta.startTime : dataEvent.meta.drills[0].startTs), 'yyyyMMddHHmm'));
          if(done === 1 || done === -1){
            await sleep(10);
          }else{
            await sleep(10000);
          } 
        }while(done === 0);
      if (done === 1) {
    requestPdf(
      urlFetch + (eventType === GAME ? `&type=game&teamOfInterest=${teamId}` : '') + '&startTime=' + 
      DateFns.format(new Date(eventType === GAME || (!dataEvent.meta.drills || !dataEvent.meta.drills[0]) ? dataEvent.meta.startTime : 
      dataEvent.meta.drills[0].startTs), 'yyyyMMddHHmm')+'&materialize=yes',
      `${dataEvent.meta.gameId}-${DateFns.format(new Date(practiceDate), 'MM-dd-yyyy')}`,
      () => {notificationDownloadFinish(`${dataEvent.meta.gameId}-${DateFns.format(new Date(practiceDate), 'MM-dd-yyyy')}.pdf`);
            fileIsDownloading(false);},
      () => {
        setLoading(false);
        setErrorPdf(true);
        setTimeout(() => setErrorPdf(false), 2500);
      }
    );
    
  }else{
    notificationDownloadError(`${dataEvent.meta.gameId}-${DateFns.format(new Date(practiceDate), 'MM-dd-yyyy')}.pdf`);
    fileIsDownloading(false);
  }
  };
  const options = [7, 14, 28];
  const checks = options.map((option) => {
    return (
      <div className="radio" key={'check-' + option}>
        <input
          id={`radio-practices-${option}`}
          name={`radio-practices-${option}`}
          type="radio"
          checked={selected === option}
          onChange={() => {
            if (selected !== option) {
              setOption(option);
            }
          }}
        />
        <label htmlFor={`radio-practices-${option}`} className="radio-label">
          {`Past ${option} Days ${option === 7 ? '(Default)' : ''}`}
        </label>
      </div>
    );
  });
  return (
    <Loader
      style={{ height: 'calc(100vh - 120px)' }}
      forceMessage={dataEvent.meta.type === FUTURE_PRACTICE ? 'Practice hasn\'t started. Start the practice to start see live performance data' : undefined}
    >
      <Row>
        <Col lg={12} xs={12}>
          <div className="head-account">
            <TabSelector show={show === 1} open={() => setShow(1)} close={() => setShow(-1)} />
          </div>
          <div className="reporting">
            <Loader style={{ height: 'calc(100vh - 202px)' }} forceLoader={loading}>
              <h5>{`Create a Report for this ${eventType}`}</h5>
              <p>The options below allow you to choose what your data will be compared to in the report.</p>
              {checks}
              <button className="btn-blue" style={download ? { opacity: 0.5, cursor: 'default', pointerEvents: 'none', color: '#FFFFFF' } : {}} onClick={clickPDF} disabled={download}>
                Create Report
              </button>
              <Alert show={errorPdf} variant={'danger'}>
                Unable to generate the pdf report
              </Alert>
            </Loader>
          </div>
        </Col>
      </Row>
    </Loader>
  );
};

export default TabReports;
